import { API } from "./utils"

export const distributions = {
  createDistribution: (data) => API.post("/distributions/", data),
  distributionsList: (params = null) => API.get("/distributions/", { params }),
  getDistribution: (id) => API.get(`/distributions/${id}/`),
  updateDistribution: (id, data) => API.patch(`/distributions/${id}/`, data),
  deleteDistribution: (id) => API.delete(`/distributions/${id}/`),
  exportDistributions: (data) => API.post("/distributions/export/", data),
  createCloseout: (data) => API.post("/distributions/closeouts/", data),
  getCloseout: (id) => API.get(`/distributions/closeouts/${id}/`),
  updateCloseout: (id, data) => API.patch(`/distributions/closeouts/${id}/`, data),
  deleteCloseout: (id) => API.delete(`/distributions/closeouts/${id}/`),
  createCloseoutTransactions: (id) => API.post(`/distributions/closeouts/${id}/create_transactions/`),
  undoCloseoutTransactions: (id) => API.delete(`/distributions/closeouts/${id}/undo_transactions/`),
  createCloseoutSnapshot: (id) => API.post(`/distributions/closeouts/${id}/snapshot/`),
  deleteCloseoutSnapshot: (id) => API.delete(`/distributions/closeouts/${id}/snapshot/`),
  refreshCloseoutSnapshot: (id, data) => API.post(`/distributions/closeouts/${id}/refresh/`, data),
  getCloseoutSnapshotList: (closeoutId, params = null) => API.get(`/distributions/closeouts/${closeoutId}/snapshot/`, { params }),
  updateSnapshotData: (closeoutId, snapshotId, data) => API.patch(`/distributions/closeouts/${closeoutId}/snapshot/${snapshotId}/`, data),
  markCloseoutDistributable: (id, distributable) => API.post(`/distributions/closeouts/${id}/distributable/`, { distributable }),
  exportSnapshot: (closeoutId, data = null) => API.post(`/distributions/closeouts/${closeoutId}/snapshot/export/`, data),
  statementsList: (params = null) => API.get("/distributions/statements/", { params }),
  getStatementDownloadUrl: (id) => API.get(`/distributions/statements/${id}/`),
}
